const verifyContactInfoActionTypes = {
  LOAD: {
    REQUEST: 'VERIFY_CONTACT_INFO.LOAD.REQUEST',
    FAILURE: 'VERIFY_CONTACT_INFO.LOAD.FAILURE',
    SUCCESS: 'VERIFY_CONTACT_INFO.LOAD.SUCCESS',
  },
};

export default verifyContactInfoActionTypes;
